import { useActiveOrg } from '~/hooks/org/useActiveOrg'

export const useRequireMemo = () => {
  const { org } = useActiveOrg()
  return org?.requireMemo ?? false
}
